import { render, staticRenderFns } from "./LinkCcdContactButton.vue?vue&type=template&id=4340aa38&scoped=true&"
import script from "./LinkCcdContactButton.vue?vue&type=script&lang=js&"
export * from "./LinkCcdContactButton.vue?vue&type=script&lang=js&"
import style0 from "./LinkCcdContactButton.vue?vue&type=style&index=0&id=4340aa38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4340aa38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4340aa38')) {
      api.createRecord('4340aa38', component.options)
    } else {
      api.reload('4340aa38', component.options)
    }
    module.hot.accept("./LinkCcdContactButton.vue?vue&type=template&id=4340aa38&scoped=true&", function () {
      api.rerender('4340aa38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/LinkCcdContactButton.vue"
export default component.exports